/**
 * Maps browser hostname (custom domain on the shared Static Web App)
 * to the BackOffice.API base URL for that tenant.
 *
 * Unknown hosts keep environment.prod.ts / environment.ts apiUrl.
 */
export const tenantHostApiMap: Record<string, string> = {
  'sesderma.flexibotapp.com': 'https://Flexibot-BackOffice-sesderma-us.azurewebsites.net',
  'backoffice.flexibotapp.com': 'https://flexibot-backoffice.azurewebsites.net',
};

/**
 * Strip trailing slashes. Call sites use `${environment.apiUrl}/api/...`,
 * so a trailing slash would produce `//api` (breaks some hosts / CORS paths).
 */
export function normalizeApiUrl(url: string): string {
  return url.trim().replace(/\/+$/, '');
}
